export * from './icons-registry.service'
